import type { AppLocale, DeepPartialMessageTree } from "@airange/shared/i18n-common";

export const microLabCommonMessages: Record<AppLocale, DeepPartialMessageTree> = {
  "zh-CN": {
    microLab: {
      shell: {
        title: "微实验后台",
        portalEntry: "学员端",
        loginPageTitle: "{centerTitle}登录",
      },
      locale: {
        zhCN: "中文",
        en: "English",
        ja: "日本語",
      },
      menu: {
        members: "成员管理",
        schemes: "实验方案",
        schemeReviews: "共享审核",
        schemeWorkbenchPrivate: "我的方案",
        schemeWorkbenchPublic: "共享方案",
        releases: "实验发布",
        runs: "实例审计",
      },
      labels: {
        username: "用户名",
        displayName: "显示名称",
        realName: "真实姓名",
        email: "邮箱",
        phone: "手机号",
        userId: "用户ID",
        currentExperimentCompleted: "已完成当前实验",
        completedVersion: "已完成版本",
        currentVersionStatus: "共享状态",
        sourceRelation: "来源关系",
        actions: "操作",
        environmentKind: "环境类型",
        environmentAsset: "环境资产",
        versionNo: "版本号",
        versionName: "版本名称",
        version: "版本",
        experimentName: "实验名称",
        schemeName: "方案名称",
        schemeCode: "方案编号",
        schemeStatus: "方案状态",
        currentStatus: "当前状态",
        parentScheme: "所属方案",
        specCategory: "规格/分类",
        topologySummary: "拓扑摘要",
        nodeCountUnit: "节点",
        networkCountUnit: "网络",
        accessPointCountUnit: "接入点",
        roles: "角色",
        member: "成员",
        organization: "组织",
        platformRoles: "平台角色",
        applicationRoles: "应用角色",
        estimatedDuration: "预计时长",
        ksaType: "KSA 类型",
        ksaLevel: "KSA 层级",
        release: "发布",
        description: "说明",
        currentVersion: "当前版本",
        tags: "标签",
        reviewStatus: "审核状态",
        scheme: "方案",
        schemeVersion: "方案版本",
        visibilityScope: "可见范围",
        manualVisible: "手册可见",
        sourceSchemeVersion: "来源方案 / 版本",
        publishedAt: "发布时间",
        closedAt: "关闭时间",
        archivedAt: "归档时间",
        targetMemberIds: "目标成员",
        targetMemberCount: "目标成员数",
        targetCount: "目标人数",
        totalRunCount: "实例总数",
        startedCount: "已开始",
        runningCount: "进行中",
        completedCount: "已完成",
        passedCount: "已通过",
        failedCount: "未通过",
        notStartedCount: "未开始",
        releaseId: "发布 ID",
        releaseCode: "发布编号",
        runRecordId: "运行记录 ID",
        hasStarted: "是否已开始",
        runCount: "轮次",
        latestAttempt: "最近轮次",
        latestResult: "最近结果",
        effectiveResult: "生效结果",
        submittedBy: "提交人",
        submittedAt: "提交时间",
        reviewedBy: "审核人",
        reviewedAt: "审核时间",
        reviewComment: "审核意见",
        schemeTags: "方案标签",
        ksaBindings: "KSA 绑定",
        memberId: "成员 ID",
        currentAttemptNo: "当前轮次",
        instanceStatus: "实例状态",
        systemResult: "系统结果",
        manualOverrideResult: "人工改判结果",
        startedAt: "开始时间",
        completedAt: "完成时间",
        lastResultAt: "最近结果时间",
        beforeResult: "改判前",
        afterResult: "改判后",
        overrideReason: "改判原因",
        operatorDisplayName: "操作人展示名",
        manualOverride: "人工改判",
        resetAndReopen: "重置重开",
        environmentSessionRef: "环境会话标识",
        checkCode: "Check 编号",
        checkName: "Check 名称",
        checkStatus: "Check 状态",
        checkPassed: "Check 是否通过",
        checkMessage: "Check 信息",
        occurredAt: "发生时间",
        sourceTaskId: "来源任务 ID",
      },
      values: {
        yes: "是",
        no: "否",
        unconfigured: "未配置",
        ksaTypes: {
          knowledge: "知识",
          skill: "技能",
          ability: "能力",
        },
        environmentKinds: {
          image: "应用镜像",
          topology: "拓扑",
        },
        reuseModes: {
          self_built: "自建方案",
          reference: "引用",
          clone: "克隆",
        },
        sharedResourceScopes: {
          mine: "我的",
          shared_with_me: "共享给我的",
          public: "公共",
          all: "全部",
        },
        catalogSources: {
          mock: "内置目录",
          environment_center: "环境中心",
        },
        statuses: {
          draft: "草稿",
          archived: "已归档",
          pending: "待判定",
          passed: "通过",
          failed: "未通过",
          not_started: "未开始",
          running: "进行中",
          completed: "已完成",
          pending_review: "待审核",
          shared: "已共享",
          offline: "已下线",
          approved: "已通过",
          rejected: "已驳回",
          published: "已发布",
          closed: "已关闭",
          active: "启用",
          inactive: "停用",
        },
        visibilityScopes: {
          all_members: "全部成员",
          targeted_members: "定向成员",
        },
      },
      enumKinds: {
        environmentKind: "环境类型",
        runStatus: "实例状态",
        runResultStatus: "结果状态",
        schemeVersionStatus: "版本状态",
        schemeStatus: "方案状态",
        releaseStatus: "发布状态",
        libraryReviewStatus: "审核状态",
        memberStatus: "成员状态",
        visibilityScope: "可见范围",
        reuseMode: "来源关系",
        ksaType: "KSA类型",
      },
      actions: {
        editScheme: "编辑方案",
        manageVersions: "管理版本",
        createVersion: "新建版本",
        editVersion: "编辑版本",
        submitSharedReview: "提交共享审核",
        confirmReview: "确认送审",
        pickSelectedEnvironmentAsset: "带回所选资产",
        pickSelectedKsa: "带回所选 KSA",
        archiveScheme: "归档方案",
        shareScheme: "共享方案",
        createScheme: "新建方案",
        referenceOrClone: "引用 / 克隆",
        offlineSharedEntry: "下线共享",
        processReview: "审核处理",
        approve: "通过",
        reject: "驳回",
        confirmApprove: "确认通过",
        pickSelectedTargetMembers: "带回所选成员",
        addTargetMembers: "新增目标成员",
        addSelectedTargetMembers: "补充所选成员",
        pickSelectedShareMembers: "带回所选共享成员",
        confirmReject: "确认驳回",
        confirmOffline: "确认下线",
        createRelease: "创建发布",
      },
    },
  },
  en: {
    microLab: {
      shell: {
        title: "Micro Lab Admin",
        portalEntry: "Learner Portal",
        loginPageTitle: "{centerTitle} Login",
      },
      menu: {
        members: "Members",
        schemes: "Schemes",
        schemeReviews: "Shared Reviews",
        schemeWorkbenchPrivate: "My Schemes",
        schemeWorkbenchPublic: "Shared Schemes",
        releases: "Releases",
        runs: "Run Audit",
      },
      labels: {
        release: "Release",
        member: "Member",
        currentVersionStatus: "Shared Status",
        sourceRelation: "Source Relation",
        actions: "Actions",
        organization: "Organization",
        environmentKind: "Environment",
        environmentAsset: "Environment Asset",
        estimatedDuration: "Estimated Duration",
        versionNo: "Version No.",
        versionName: "Version Name",
        version: "Version",
        experimentName: "Experiment Name",
        schemeName: "Scheme Name",
        schemeCode: "Scheme Code",
        schemeStatus: "Scheme Status",
        currentStatus: "Current Status",
        parentScheme: "Scheme",
        sourceSchemeVersion: "Source Scheme / Version",
        specCategory: "Spec / Category",
        topologySummary: "Topology Summary",
        nodeCountUnit: "nodes",
        networkCountUnit: "networks",
        accessPointCountUnit: "access points",
        username: "Username",
        displayName: "Display Name",
        realName: "Real Name",
        email: "Email",
        phone: "Phone",
        userId: "User ID",
        currentExperimentCompleted: "Completed Current Lab",
        completedVersion: "Completed Version",
        completedAt: "Completed At",
        tags: "Tags",
        targetMemberCount: "Target Members",
        targetCount: "Target Count",
        totalRunCount: "Total Runs",
        startedCount: "Started",
        runningCount: "Running",
        completedCount: "Completed",
        passedCount: "Passed",
        failedCount: "Failed",
        notStartedCount: "Not Started",
        archivedAt: "Archived At",
        submittedBy: "Submitted By",
        submittedAt: "Submitted At",
        reviewedBy: "Reviewed By",
        reviewedAt: "Reviewed At",
        reviewComment: "Review Comment",
        schemeTags: "Scheme Tags",
        ksaBindings: "KSA Bindings",
        runRecordId: "Run Record ID",
        memberId: "Member ID",
        currentAttemptNo: "Attempt No.",
        instanceStatus: "Instance Status",
        systemResult: "System Result",
        manualOverrideResult: "Manual Override Result",
        beforeResult: "Result Before Override",
        afterResult: "Result After Override",
        overrideReason: "Override Reason",
        operatorDisplayName: "Operator Display Name",
        manualOverride: "Manual Override",
        resetAndReopen: "Reset and Reopen",
        environmentSessionRef: "Environment Session Ref",
        checkCode: "Check Code",
        checkName: "Check Name",
        checkStatus: "Check Status",
        checkPassed: "Check Passed",
        checkMessage: "Check Message",
        occurredAt: "Occurred At",
        sourceTaskId: "Source Task ID",
        ksaType: "KSA Type",
        ksaLevel: "KSA Level",
      },
      values: {
        unconfigured: "Unconfigured",
        ksaTypes: {
          knowledge: "Knowledge",
          skill: "Skill",
          ability: "Ability",
        },
        environmentKinds: {
          image: "Application Image",
          topology: "Topology",
        },
        statuses: {
          active: "Active",
          inactive: "Inactive",
        },
        reuseModes: {
          self_built: "Self-built",
          reference: "Reference",
          clone: "Clone",
        },
        sharedResourceScopes: {
          mine: "Mine",
          shared_with_me: "Shared with me",
          public: "Public",
          all: "All",
        },
        catalogSources: {
          mock: "Built-in Catalog",
          environment_center: "Environment Center",
        },
      },
      actions: {
        editScheme: "Edit Scheme",
        manageVersions: "Manage Versions",
        createVersion: "Create Version",
        editVersion: "Edit Version",
        submitSharedReview: "Submit Shared Review",
        confirmReview: "Confirm Review Submission",
        pickSelectedEnvironmentAsset: "Use Selected Asset",
        pickSelectedKsa: "Use Selected KSA",
        archiveScheme: "Archive Scheme",
        shareScheme: "Share Scheme",
        createScheme: "Create Scheme",
        referenceOrClone: "Reference / Clone",
        offlineSharedEntry: "Take Offline",
        processReview: "Process Review",
        approve: "Approve",
        reject: "Reject",
        confirmApprove: "Confirm Approval",
        pickSelectedTargetMembers: "Use Selected Members",
        addTargetMembers: "Add Target Members",
        addSelectedTargetMembers: "Add Selected Members",
        pickSelectedShareMembers: "Use Selected Share Members",
        confirmReject: "Confirm Rejection",
        confirmOffline: "Confirm Offline",
      },
    },
  },
  ja: {
    microLab: {
      shell: {
        title: "Micro Lab Admin",
        portalEntry: "Learner Portal",
        loginPageTitle: "{centerTitle} Login",
      },
      menu: {
        members: "メンバー管理",
        schemes: "実験プラン",
        schemeReviews: "共有審査",
        schemeWorkbenchPrivate: "自分のプラン",
        schemeWorkbenchPublic: "共有プラン",
        releases: "実験公開",
        runs: "インスタンス監査",
      },
      actions: {
        pickSelectedShareMembers: "選択した共有メンバーを反映",
      },
    },
  },
};
